import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-delete',
  templateUrl: './delete.component.html',
  styleUrls: ['./delete.component.scss']
})
export class DeleteComponent {
  constructor(private dialog:MatDialog){}
  openokdialog()
  {
   this.dialog.getDialogById('delete')?.close(true)
  }
  close()
  {
     this.dialog.getDialogById('delete')?.close(false)
  }
}
